<template>
  <div data-v-a12142ec="" data-v-2ac6a5fc="" class="aboutNew">
    <div data-v-a12142ec="" class="sect1">
      <div data-v-a12142ec="" class="box">
        <div data-v-a12142ec="" class="detail">
          <h1 data-v-a12142ec="">{{$store.state.appInfo.title}}优势</h1>
          <div class="advantage-grid">
            <p data-v-a12142ec="" class="advantage-item">单日提款高达<span data-v-a12142ec="" class="highlight">2,000万</span></p>
            <p data-v-a12142ec="" class="advantage-item">随时洗码1秒到账</p>
            <p data-v-a12142ec="" class="advantage-item">单笔下注高达<span data-v-a12142ec="" class="highlight">200万</span></p>
            <p data-v-a12142ec="" class="advantage-item">支持<span data-v-a12142ec="" class="highlight">USDT、BTC</span>多币种到账</p>
            <p data-v-a12142ec="" class="advantage-item">澳门、菲律宾各大<span data-v-a12142ec="" class="highlight">赌场出款</span></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. 游戏平台区域 - 卡片化优化 -->
    <div data-v-a12142ec="" class="sect2">
      <h1 data-v-a12142ec="" class="section-title">众多游戏平台</h1>
      <p data-v-a12142ec="" class="section-desc">
        我们提供丰富游戏项目：百家乐、龙宝、骰宝、21点、体育竞技、轮盘、炸金花、三公、温州牌九、牛牛、德州扑克等
      </p>
      <div data-v-a12142ec="" class="gameList">
        <div data-v-a12142ec="" class="gthmb">
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game1.8495e00d.png" alt="游戏1" /></div>
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game2.f196b9de.png" alt="游戏2" /></div>
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game3.abcdaab4.png" alt="游戏3" /></div>
        </div>
        <div data-v-a12142ec="" class="gthmb">
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game4.775a38b6.png" alt="游戏4" /></div>
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game5.800cf51f.png" alt="游戏5" /></div>
          <div data-v-a12142ec="" class="game-card"><img data-v-a12142ec="" src="/static/image/game6.e05e5861.png" alt="游戏6" /></div>
        </div>
      </div>
    </div>

    <!-- 3. 年度报告区域 - 格局修复 -->
    <div data-v-a12142ec="" class="sect3">
      <h1 data-v-a12142ec="" class="section-title">年度报告</h1>
      <div data-v-a12142ec="" class="reportList">
        <div data-v-a12142ec="" class="report-card">
          <div class="report-header">
            <span class="report-year">2024年度</span>
            <span class="report-more"><i class="dots">• • •</i></span>
          </div>
          <div class="report-content">
            <p data-v-a12142ec="" class="report-item">全年成交 <span class="highlight">2089亿</span></p>
            <p data-v-a12142ec="" class="report-item">新增会员注册用户 <span class="highlight">532.64万人</span></p>
            <p data-v-a12142ec="" class="report-item">全年送出优惠高达 <span class="highlight">12.14亿元</span></p>
          </div>
        </div>
        <div data-v-a12142ec="" class="report-card">
          <div class="report-header">
            <span class="report-year">2023年度</span>
            <span class="report-more"><i class="dots">• • •</i></span>
          </div>
          <div class="report-content">
            <p data-v-a12142ec="" class="report-item">全年成交 <span class="highlight">1971.82亿</span></p>
            <p data-v-a12142ec="" class="report-item">新增会员注册用户 <span class="highlight">323.05万人</span></p>
            <p data-v-a12142ec="" class="report-item">全年送出优惠高达 <span class="highlight">12.1亿元</span></p>
          </div>
        </div>
        <div data-v-a12142ec="" class="report-card">
          <div class="report-header">
            <span class="report-year">2022年度</span>
            <span class="report-more"><i class="dots">• • •</i></span>
          </div>
          <div class="report-content">
            <p data-v-a12142ec="" class="report-item">全年成交 <span class="highlight">1507.61亿</span></p>
            <p data-v-a12142ec="" class="report-item">新增会员数较2021年增长 <span class="highlight">159.63%</span></p>
            <p data-v-a12142ec="" class="report-item">全年送出优惠高达 <span class="highlight">7.9亿元</span></p>
          </div>
        </div>
      </div>
    </div>

    <!-- 4. 活动Banner区域 - 圆角优化 -->
    <div data-v-a12142ec="" class="sect4">
      <div data-v-a12142ec="" class="banner">
        <img data-v-a12142ec="" src="/static/image/banner.df0ea208.jpg" alt="AG现场活动" />
      </div>
      <p data-v-a12142ec="" class="banner-desc">
        AG现场参观豪华游艇主题party，邀您感受菲律宾的热情
      </p>
    </div>

    <!-- 5. 全民俱乐部区域 - 对齐修复 -->
    <div data-v-a12142ec="" class="sect5">
      <h1 data-v-a12142ec="" class="section-title">全民俱乐部</h1>
      <p data-v-a12142ec="" class="section-desc">每月8/18/28爽领分红</p>
      <div data-v-a12142ec="" class="shareholderList">
        <div class="shareholder-grid">
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb1"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">专属经理</span>
              <span data-v-a12142ec="" class="shareholder-desc">一对一服务</span>
            </div>
          </div>
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb2"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">专属域名</span>
              <span data-v-a12142ec="" class="shareholder-desc">私人定制专属通道</span>
            </div>
          </div>
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb3"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">月月分红</span>
              <span data-v-a12142ec="" class="shareholder-desc">最高可享200,000股</span>
            </div>
          </div>
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb4"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">账号回购</span>
              <span data-v-a12142ec="" class="shareholder-desc">{{$store.state.appInfo.title}}官方保底账号回购1,400,000元</span>
            </div>
          </div>
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb5"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">晋级礼金</span>
              <span data-v-a12142ec="" class="shareholder-desc">累计最高可享6,015,500元</span>
            </div>
          </div>
          <div data-v-a12142ec="" class="shareholder-item">
            <i data-v-a12142ec="" class="orb orb6"></i>
            <div class="shareholder-text">
              <span data-v-a12142ec="" class="shareholder-label">免息贷款</span>
              <span data-v-a12142ec="" class="shareholder-desc">最高可享1,400,000元</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 6. 品牌历程区域 - 横向滚动优化 -->
    <div data-v-a12142ec="" class="sect6">
      <h1 data-v-a12142ec="" class="section-title">品牌发展历程</h1>
      <div data-v-a12142ec="" class="promoList">
        <div class="promo-scroll">
          <div data-v-a12142ec="" class="promo-card">
            <img data-v-a12142ec="" src="/static/image/promo1.a575b4d1.png" alt="2021年：品牌成立" />
            <div class="promo-desc">2021年：品牌成立，开启线上服务</div>
          </div>
          <div data-v-a12142ec="" class="promo-card">
            <img data-v-a12142ec="" src="/static/image/promo2.ff3c67ac.png" alt="2022年：拓展游戏品类" />
            <div class="promo-desc">2022年：拓展10+游戏品类，会员突破百万</div>
          </div>
          <div data-v-a12142ec="" class="promo-card">
            <img data-v-a12142ec="" src="/static/image/promo3.b3847e9f.png" alt="2023年：全球化布局" />
            <div class="promo-desc">2023年：开启全球化布局，新增3个海外站点</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about',
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // 初始化品牌历程滚动容器高度（适配图片尺寸）
    const adjustPromoHeight = () => {
      const promoCard = document.querySelector('.promo-card');
      const promoScroll = document.querySelector('.promo-scroll');
      if (promoCard && promoScroll) {
        promoScroll.style.height = `${promoCard.offsetHeight + 20}px`;
      }
    };
    adjustPromoHeight();
    window.addEventListener('resize', adjustPromoHeight);
    
    // 组件销毁时移除监听，避免内存泄漏
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', adjustPromoHeight);
    });
  },
};
</script>

<style lang="scss" scoped>
// 1. 全局变量（完整定义，无缺失）
$white: #ffffff;
$gray-50: #f9fafb;    // 最浅灰（背景）
$gray-100: #f3f4f6;   // 浅灰（边框/轨道）
$gray-200: #e5e7eb;   // 中浅灰（分割线）
$gray-300: #d1d5db;   // 中灰（滚动条滑块）
$gray-400: #9ca3af;   // 中深灰（滚动条hover）
$gray-500: #6b7280;   // 深灰（禁用文本）
$gray-600: #4b5563;   // 更深灰（普通文本）
$gray-700: #374151;   // 最深灰（标题文本）
$primary: #4285f4;     // 主色（蓝色，用于强调）
$primary-light-5: rgba(66, 133, 244, 0.05);  // 主色5%透明度
$primary-light-10: rgba(66, 133, 244, 0.1); // 主色10%透明度
$highlight: #ef4444;   // 强调色（红色，用于关键数据）
$accent: #f59e0b;      // 辅助色（暖黄，用于按钮/装饰）
$accent-90: rgba(245, 158, 11, 0.9); // 辅助色90%透明度（渐变）
$radius: 12px;         // 统一圆角（现代感）
$shadow: 0 4px 16px rgba(0, 0, 0, 0.06); // 柔和阴影（分层）
$transition: all 0.3s ease; // 统一过渡（交互反馈）

// 2. 基础样式重置
@media only screen and (min-width:701px){html[data-v-a12142ec]{font-size:140px}}
@media only screen and (max-width:700px){html[data-v-a12142ec]{font-size:100px}}
@media only screen and (max-width:320px){html[data-v-a12142ec]{font-size:85px}}
body[data-v-a12142ec]{font-size:14px; background-color:$gray-50;}
h1[data-v-a12142ec],h2[data-v-a12142ec],h3[data-v-a12142ec],h4[data-v-a12142ec],h5[data-v-a12142ec],p[data-v-a12142ec],ul[data-v-a12142ec]{padding:0;margin:0;}
div[data-v-a12142ec]{box-sizing:border-box;}
a[data-v-a12142ec]{text-decoration:none;cursor:pointer;}

// 3. 外层容器（居中+白色基调）
.aboutNew[data-v-a12142ec]{
  font-size:14px;
  color:$gray-600;
  background:$gray-50;
  max-width:1200px;
  margin:0 auto;
  padding:30px 15px; // 关键修复1：将 padding:30px 2px 改为 30px 15px，避免左右内边距过小导致内容贴边
  display:flex;
  flex-direction:column;
  gap:40px;
}

// 4. 通用组件样式（标题+描述）
.section-title[data-v-a12142ec]{
  font-size:22px;
  color:$gray-700;
  font-weight:600;
  margin-bottom:16px;
  position:relative;
  padding-left:16px;
  
  &::before{
    content:'';
    position:absolute;
    left:0;
    top:50%;
    transform:translateY(-50%);
    width:4px;
    height:20px;
    background:$primary;
    border-radius:2px;
  }
}

.section-desc[data-v-a12142ec]{
  font-size:14px;
  color:$gray-600;
  line-height:1.6;
  margin-bottom:24px;
  padding-left:16px;
}

.sect1[data-v-a12142ec]{
  width:100%;
  min-height: 200px; // 保留最小高度，防止内容过少时容器过矮
  position:relative;
  border-radius:$radius;
  border: 1px solid $gray-200;
  overflow:hidden;
  background:linear-gradient(180deg, $primary-light-5, $primary-light-10);
  border-radius:$radius;
  .box[data-v-a12142ec]{
    position:relative; 
    margin:0 auto; // 居中容器
    max-width: 1100px; // 限制容器最大宽度，与外层保持一致
    background:$white;
    border-radius:$radius;
    box-shadow:$shadow;
    padding:30px;
    margin-bottom:0; 
  }
  
  .detail h1[data-v-a12142ec]{
    font-size:24px;
    color:$gray-700;
    margin-bottom:24px;
    font-weight:600;
  }
  
  .advantage-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(220px, 1fr));
    gap:16px;
  }
  
  .advantage-item[data-v-a12142ec]{
    font-size:15px;
    color:$gray-600;
    line-height:24px;
    padding-left:24px;
    position:relative;
    
    &::before{
      content:'✓';
      position:absolute;
      left:0;
      top:2px;
      color:$primary;
      font-weight:600;
    }
    
    .highlight[data-v-a12142ec]{
      color:$highlight;
      font-weight:600;
      margin:0 4px;
    }
  }
}

// 5.2 游戏平台区域
.sect2[data-v-a12142ec]{
  width:100%;
  
  .gameList[data-v-a12142ec]{
    padding:0 2px;
  }
  
  .gthmb[data-v-a12142ec]{
    display:flex;
    gap:16px;
    margin-bottom:5px;
  }
  
  .game-card[data-v-a12142ec]{
    flex:1;
    background:$white;
    border-radius:$radius;
    overflow:hidden;
    box-shadow:$shadow;
    transition:$transition;
    
    &:hover{
      transform:translateY(-4px);
      box-shadow:0 8px 24px rgba(0,0,0,0.08);
    }
    
    img[data-v-a12142ec]{
      width:100%;
      height:100%;
      object-fit:cover;
      display:block;
    }
  }
  
  // 移动端适配（2列布局）
  @media (max-width:768px){
    .gthmb[data-v-a12142ec]{
      flex-wrap:wrap;
    }
    .game-card[data-v-a12142ec]{
      width:calc(50% - 8px);
    }
    .game-card img[data-v-a12142ec]{
      height:140px;
    }
  }
}

// 5.3 年度报告区域
.sect3[data-v-a12142ec]{
  width:100%;
  
  .reportList[data-v-a12142ec]{
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(320px, 1fr));
    gap:10px;
    padding:0 2px;
  }
  
  .report-card[data-v-a12142ec]{
    background:$white;
    border-radius:$radius;
    box-shadow:$shadow;
    padding:24px;
    transition:$transition;
    
    &:hover{
      transform:translateY(-3px);
      box-shadow:0 6px 20px rgba(0,0,0,0.07);
    }
  }
  
  .report-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:16px;
    padding-bottom:12px;
    border-bottom:1px solid $gray-100;
    
    .report-year{
      font-size:16px;
      color:$gray-700;
      font-weight:500;
    }
    
    .report-more{
      color:$primary;
      cursor:pointer;
      
      .dots{
        font-size:18px;
        letter-spacing:4px;
      }
    }
  }
  
  .report-content{
    .report-item[data-v-a12142ec]{
      font-size:14px;
      color:$gray-600;
      line-height:26px;
      margin-bottom:8px;
      
      .highlight{
        color:$highlight;
        font-weight:600;
      }
    }
  }
}

// 5.4 活动Banner区域
.sect4[data-v-a12142ec]{
  width:100%;
  padding:0 2px;
  
  .banner[data-v-a12142ec]{
    border-radius:$radius;
    overflow:hidden;
    box-shadow:$shadow;
    margin-bottom:16px;
  }
  
  .banner img[data-v-a12142ec]{
    width:100%;
    height:auto;
    display:block;
  }
  
  .banner-desc[data-v-a12142ec]{
    font-size:15px;
    color:$gray-600;
    text-align:center;
    padding:8px 0;
    font-weight:500;
  }
}

// 5.5 全民俱乐部区域
.sect5[data-v-a12142ec]{
  width:100%;
  padding:0 2px;
  
  .shareholderList[data-v-a12142ec]{
    background:$white;
    border-radius:$radius;
    box-shadow:$shadow;
    padding:24px;
  }
  
  .shareholder-grid{
    display:grid;
    grid-template-columns:repeat(auto-fit, minmax(280px, 1fr));
    gap:20px;
  }
  
  .shareholder-item[data-v-a12142ec]{
    display:flex;
    align-items:center;
    gap:14px;
    border-radius:$radius;
    transition:$transition;
    
    &:hover{
      background:$gray-50;
    }
  }
  
  .orb[data-v-a12142ec]{
    width:28px;
    height:28px;
    flex-shrink:0;
    background-size:28px auto !important;
  }
  
  .shareholder-text{
    .shareholder-label[data-v-a12142ec]{
      font-size:15px;
      color:$gray-700;
      font-weight:500;
      display:block;
      margin-bottom:4px;
    }
    
    .shareholder-desc[data-v-a12142ec]{
      font-size:13px;
      color:$gray-600;
      line-height:1.5;
    }
  }
  
  // 图标路径（确保显示正常）
  .orb1[data-v-a12142ec]{background:url(/static/style/orb1.59d96e05.png) 0 no-repeat;filter:brightness(0.9);}
  .orb2[data-v-a12142ec]{background:url(/static/style/orb2.375ffa58.png) 0 no-repeat;filter:brightness(0.9);}
  .orb3[data-v-a12142ec]{background:url(/static/style/orb3.07cea464.png) 0 no-repeat;filter:brightness(0.9);}
  .orb4[data-v-a12142ec]{background:url(/static/style/orb4.ed2954c7.png) 0 no-repeat;filter:brightness(0.9);}
  .orb5[data-v-a12142ec]{background:url(/static/style/orb5.5e73e900.png) 0 no-repeat;filter:brightness(0.9);}
  .orb6[data-v-a12142ec]{background:url(/static/style/orb6.6318d528.png) 0 no-repeat;filter:brightness(0.9);}
}

// 5.6 品牌历程区域
.sect6[data-v-a12142ec]{
  width:100%;
  padding:0 2px;
  
  .promoList[data-v-a12142ec]{
    background:$white;
    border-radius:$radius;
    box-shadow:$shadow;
    padding:22px;
  }
  
  .promo-scroll{
    overflow-x:auto;
    overflow-y:hidden;
    padding-bottom:12px;
    display:flex;
    gap:24px;
    width:100%;
    &::-webkit-scrollbar{height:6px;}
    &::-webkit-scrollbar-track{background:$gray-100;border-radius:3px;}
    &::-webkit-scrollbar-thumb{background:$gray-300;border-radius:3px;}
    &::-webkit-scrollbar-thumb:hover{background:$gray-400;}
  }
  
  .promo-card[data-v-a12142ec]{
    min-width:280px;
    border-radius:$radius;
    overflow:hidden;
    box-shadow:$shadow;
    transition:$transition;
    
    &:hover{
      transform:translateY(-3px);
      box-shadow:0 6px 16px rgba(0,0,0,0.08);
    }
    
    img[data-v-a12142ec]{
      width:100%;
      height:180px;
      object-fit:cover;
      display:block;
    }
    
    .promo-desc{
      padding:16px;
      font-size:14px;
      color:$gray-600;
      line-height:1.5;
      background:$white;
    }
  }
}

// 6. 兼容公共样式（按钮/弹窗等）
.form_fields[data-v-a12142ec]{padding:0 0 0 15px;background:#fff;}
.form_fields .form_field[data-v-a12142ec]{display:flex;align-items:center;}
.form_fields .form_field .label[data-v-a12142ec]{width:.76rem;font-size:.16rem;color:#333;white-space:nowrap;}
.form_fields .form_field input[data-v-a12142ec]{width:100%;height:.43rem;padding-left:.12rem;font-size:.16rem;line-height:.43rem;border:0;outline:0;}
.form_fields .form_field input[data-v-a12142ec]::-webkit-input-placeholder{color:#ccc;}

// 图片懒加载动画
img[lazy=error][data-v-a12142ec],img[lazy=loading][data-v-a12142ec]{
  position:absolute;top:0;right:0;bottom:0;left:0;
  width:22px!important;height:22px!important;margin:auto;
  border:2px solid $accent;border-bottom-color:transparent;border-radius:100%;
  animation:rotate-data-v-a12142ec .75s linear infinite;
}
@keyframes rotate-data-v-a12142ec{0%{transform:rotate(0)}50%{transform:rotate(180deg)}to{transform:rotate(1turn)}}

// 弹窗样式
.common-pop[data-v-a12142ec]{
  background:rgba(0,0,0,.5);position:fixed;top:0;left:0;right:0;bottom:0;
  z-index:100;display:flex;align-items:center;justify-content:center;
}
.common-pop .popup[data-v-a12142ec]{
  width:315px;background:#fff;box-shadow:0 4px 20px rgba(0,0,0,.15);border-radius:$radius;
}
.common-pop .popup .pop-head[data-v-a12142ec]{
  height:44px;text-align:center;font-size:16px;font-weight:600;color:$gray-700;
  line-height:44px;border-bottom:1px solid $gray-100;
}
.common-pop .popup .pop-close[data-v-a12142ec]{
  width:16px;height:16px;top:14px;right:16px;
  background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABL0lEQVRIx63WuW7DMAyA4V/yA6ZLayCJu/KZtDZors0PaKSD6cBAbYk6NNo0v5DR5QBCCB3wA4wi8qThCCF8Ah/At4hMTrFfoAcm4NgKDSF8AVegAx7AyWtlvcZ0wFUDW2KocfHAqJUtoxrdwFBjdImA7PZGcp1E5OEMgWY0hQH45akmPe60t2+BAbjSD0u/cbUJcn/gJmhNVNKNXTCVEHjlYkkwgZKLmcAIuh4mzAwmUDMGq3VoGK/Cd/mgVndju6VZe2/rSZPcBqMVRrAz89LIPmVKFv5ZRO4a0zMf3uZKc7e2N7aKzUJ9DQagy2Gvvf9OGVeDGSvdPp5KNuISNHXFMGNW1LXELKhnvqQ2wyA6kQ4eGIBl+lZjEfQJDMt/2AEX5qt+NbbR3gMwiMj0B1Z0CwG5IivjAAAAAElFTkSuQmCC) no-repeat;background-size:100% 100%;
}
.common-pop .popup .pop-content[data-v-a12142ec]{padding:20px;padding-bottom:30px;}

// 按钮样式（无颜色运算错误）
.common-button[data-v-a12142ec]{
  height:46px;line-height:46px;font-size:16px;border-radius:$radius;
  background:linear-gradient(224deg, $accent, $accent-90);
  color:#482000;font-weight:600;margin-top:20px;
}
.common-button.disabled[data-v-a12142ec]{
  background:#e5e7eb;color:$gray-500; // 变量已定义
}
</style>


// WEBPACK FOOTER //
// src/components/main/about.vue